import { put, spawn, takeLatest } from 'redux-saga/effects';
import { get, post, postForm } from 'utils/api/api';
import controlledCall from 'utils/services/controlledSaga';
import { appActions } from 'commons/reducer/commons.reducer';
import { history } from 'utils/history';
import { unformatParse } from 'utils/functions';
import { NEW_PAYMENT, newPaymentActions } from '../reducer/newPayment.reducer';

function* initialQuery() {
  yield takeLatest(NEW_PAYMENT.INITIAL_QUERY, function* (action) {
    yield controlledCall(
      get,
      `api/v1/payments?${new URLSearchParams({ guaranteeId: action.controls.guaranteeId })}`,
      undefined,
      newPaymentActions.initialQuerySuccess,
      newPaymentActions.initialQueryFail,
    );
  });
}

function* getStateFromApi() {
  yield takeLatest(NEW_PAYMENT.GET_STATE_FROM_API, function* (action) {
    const successFunction = (payload) => ({
      type: NEW_PAYMENT.GET_STATE_FROM_API_SUCCESS,
      payload,
    });

    const failFunction = () => ({ type: NEW_PAYMENT.GET_STATE_FROM_API_FAIL });

    yield controlledCall(
      get,
      `api/v1/guarantees/${action.controls.guaranteeId}/to_payment`,
      undefined,
      successFunction,
      failFunction,
    );
  });
}

function* doPaymentProp() {
  yield takeLatest(NEW_PAYMENT.DO_PAYMENT, function* (action) {
    yield put(appActions.setLoader('doPaymentProp', true));
    const { amount, paymentMode, toPayAmount, totalPayments } = action.controls;
    const data = new FormData();
    const amounts = [];
    action.controls.receipts.forEach((receipt) => {
      data.append(`receipts|${receipt.index}|`, receipt.file, receipt.file.name);
      amounts.push({
        index: receipt.index,
        amount: receipt.amount,
        issuerTaxNumber: receipt.issuerTaxNumber || null,
      });
    });
    data.append('guaranteeId', action.guaranteeId);
    data.append('amounts', JSON.stringify(amounts));

    const result = yield controlledCall(
      postForm,
      'api/v1/payments/receipt',
      data,
      newPaymentActions.doPaymentSuccess,
    );

    // eslint-disable-next-line no-console
    console.log('[doPaymentProp] API response:', result);

    if (!result?.error) {
      yield put(appActions.setSuccess('Se han subido los comprobantes de pago'));

      if (!action.paid) {
        result.paymentData.isProperty = action.isProperty;
        yield put(appActions.setPaymentModal(result.paymentData));
      }

      if (result.showAuctionMessage) {
        if (action.isProperty && action.isBidding && action.biddingEmail) {
          yield put(
            appActions.setEmailReminder(
              `Recordar enviar oferta a notaria : ${action.biddingEmail} `,
            ),
          );
        } else {
          yield put(
            appActions.setGotoAuction(
              'Podrá ingresar al remate una vez se apruebe su recibo mediante el siguiente enlace.',
            ),
          );
        }
      }

      if (action.isProperty) {
        // Propiedades queda igual que antes
        history.push(
          action.paid ? `/guarantee/prop/finishPayment?success=true` : '/payments',
          action.paid ? { paid: true } : null,
        );
      } else {
        if (action.paid) {
          history.push(`/guarantee/goods/finishPayment?success=true`, {
            date: action.auctionDate,
            auctionType: action.auctionType,
          });
        } else {
          history.push(`/guarantee/goods/finishPayment?success=false`, {
            date: action.auctionDate,
            auctionType: action.auctionType,
            toPayAmount:
              typeof toPayAmount === 'number'
                ? toPayAmount
                : toPayAmount != null
                ? Number(toPayAmount)
                : null,
            totalPayments:
              typeof totalPayments === 'number'
                ? totalPayments
                : totalPayments != null
                ? Number(totalPayments)
                : null,
          });
        }
      }
    }

    yield put(appActions.setLoader('doPaymentProp', false));
  });
}

export default function* newPaymentSagaV2() {
  yield spawn(getStateFromApi);
  yield spawn(initialQuery);
  yield spawn(doPaymentProp);
}
